import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'

// Registers the selected organisation's id (and name, when known) as PostHog super
// properties, clearing them again if the user deselects (e.g. switches to the
// add-new-org flow) so events are not attributed to a school the user abandoned.
export const useOrganisationAnalyticsEffect = (organisationId?: string, organisationName?: string) => {
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) {
      return undefined
    }

    if (organisationId) {
      posthog.register({ organisationId })

      // Name shares the id's lifecycle, but the watched sources can momentarily
      // disagree, so clear a stale name rather than leave it attached.
      if (organisationName) {
        posthog.register({ organisationName })
      } else {
        posthog.unregister('organisationName')
      }
    } else {
      posthog.unregister('organisationId')
      posthog.unregister('organisationName')
    }

    // Clear attribution when the form unmounts so it can't leak onto later events.
    return () => {
      posthog.unregister('organisationId')
      posthog.unregister('organisationName')
    }
  }, [posthog, organisationId, organisationName])
}
